import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Ambulance = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="ambulance icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3C0.895431 3 0 3.89543 0 5L0 17C0 18.1046 0.89543 19 2 19C2 17.067 3.567 15.5 5.5 15.5C7.433 15.5 9 17.067 9 19H14C14 17.067 15.567 15.5 17.5 15.5C19.433 15.5 21 17.067 21 19H22C23.1046 19 24 18.1046 24 17V13.2361C24 12.4785 23.572 11.786 22.8944 11.4472L20.5963 10.2981C20.2092 10.1046 19.8954 9.79077 19.7019 9.40372L17.0528 4.10557C16.714 3.428 16.0215 3 15.2639 3H2ZM7 6V8H5V10H7V12H9V10H11V8H9V6H7ZM15 6C15 5.44772 15.4477 5 16 5H16.5L19 10H16C15.4477 10 15 9.55228 15 9V6ZM7.5 19C7.5 20.1046 6.60457 21 5.5 21C4.39543 21 3.5 20.1046 3.5 19C3.5 17.8954 4.39543 17 5.5 17C6.60457 17 7.5 17.8954 7.5 19ZM19.5 19C19.5 20.1046 18.6046 21 17.5 21C16.3954 21 15.5 20.1046 15.5 19C15.5 17.8954 16.3954 17 17.5 17C18.6046 17 19.5 17.8954 19.5 19Z"
    />
  </svg>
)
